import { CircularProgressbar } from 'react-circular-progressbar';
import './featured.scss';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import 'react-circular-progressbar/dist/styles.css';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Featured = ({ salesData }) => {
  const {
    todaySales = 0,
    yesterdaySales = 0,
    weekSales = 0,
    monthSales = 0,
    growthPercent = 0,
  } = salesData || {};

  const progressValue = Math.min(Math.abs(growthPercent), 100);
  const isPositive = growthPercent >= 0;

  return (
    <div className="featured">
      <div className="top">
        <h1 className="title">Total Sales</h1>
        <MoreVertIcon fontSize="small" />
      </div>

      <div className="bottom">
        <div className="featuredChart">
          <CircularProgressbar
            value={progressValue}
            text={`${Math.round(progressValue)}%`}
            strokeWidth={10}
          />
        </div>

        <p className="title">Total Sales Today</p>
        <p className="amount">RM {Number(todaySales).toFixed(2)}</p>

        <p className="desc">
          {isPositive
            ? 'Sales increased compared to yesterday'
            : 'Sales decreased compared to yesterday'}
        </p>

        <div className="summary">
          <div className="item">
            <div className="itemTitle">Yesterday</div>
            <div className={`itemResult ${yesterdaySales > 0 ? 'position' : 'negetive'}`}>
              {yesterdaySales > 0 ? (
                <KeyboardArrowUpIcon fontSize="small" />
              ) : (
                <KeyboardArrowDownIcon fontSize="small" />
              )}
              <div className="resultAmount">RM {Number(yesterdaySales).toFixed(2)}</div>
            </div>
          </div>

          <div className="item">
            <div className="itemTitle">This Week</div>
            <div className={`itemResult ${weekSales >= todaySales ? 'position' : 'negetive'}`}>
              {weekSales >= todaySales ? (
                <KeyboardArrowUpIcon fontSize="small" />
              ) : (
                <KeyboardArrowDownIcon fontSize="small" />
              )}
              <div className="resultAmount">RM {Number(weekSales).toFixed(2)}</div>
            </div>
          </div>

          <div className="item">
            <div className="itemTitle">This Month</div>
            <div className={`itemResult ${monthSales >= weekSales ? 'position' : 'negetive'}`}>
              {monthSales >= weekSales ? (
                <KeyboardArrowUpIcon fontSize="small" />
              ) : (
                <KeyboardArrowDownIcon fontSize="small" />
              )}
              <div className="resultAmount">RM {Number(monthSales).toFixed(2)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Featured;